<template>
  <v-app id="inspire" style="background-color: #1e88e5">
    <v-layout wrap justify-center>
      <v-flex xs10 md3 align-self-center>
        <v-card outlined tile>
          <v-layout xs12 sm12 md12 py-8 wrap justify-center>
            <v-flex>
              <v-layout wrap justify-center>
                <v-flex xs12 md8 text-center>
                  <span class="login_head">
                    <img
                      src="../../assets/logo.jpg"
                      height="100px"
                      width="100px"
                      class="mt-2"
                    />
                  </span>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-center>
                <v-flex xs12 md8 text-center>
                  <span class="login_head">Log in</span>
                </v-flex>
              </v-layout>

              <v-layout wrap justify-center pt-0>
                <v-flex xs12 sm6 md10 pt-5 px-2>
                  <v-text-field
                    label="Username"
                    dense
                    outlined
                    v-model="username"
                    prepend-inner-icon="mdi-account-circle"
                    :rules="[rules.required]"
                    :error-messages="msg_username"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm10 md10 px-2>
                  <v-text-field
                    label="Password"
                    dense
                    outlined
                    v-model="password"
                    prepend-inner-icon="mdi-lock"
                    type="password"
                    :rules="[rules.required]"
                    :error-messages="msg_password"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout v-if="msg" pt-4 wrap justify-center>
                <v-flex xs12 md3 pa-2 text-center>
                  <span style="font-size: 14px; color: red">{{ msg }}</span>
                </v-flex>
              </v-layout>

              <v-layout wrap justify-center>
                <v-flex xs12 md10 text-center>
                  <v-btn
                    color="primary"
                    width="100%"
                    class="text-capitalize py-4"
                    dark
                    small
                    :ripple="true"
                    @click="login"
                    >Log In</v-btn
                  >
                </v-flex>
              </v-layout>
              <!-- <v-layout wrap justify-center>
          <v-flex xs12 md3 pt-5 text-center>
            <router-link to="/ForgotPassword">
              <span style="font-size:14px;">Forgot Password?</span>
            </router-link>
          </v-flex>
        </v-layout> -->
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
import axios from "axios";
import store from "../../store";
// import Login from "@/components/Login/loginMain.vue";
export default {
  components: {
    // Login
  },

  data() {
    return {
      appLoading: false,
      username: null,
      password: null,

      msg: null,
      msg_username: null,
      msg_password: null,
      rules: {
        required: (value) => !!value || "Required",
      },
    };
  },

  methods: {
    login() {
      this.appLoading = true;
      var logindata = {};
      logindata["username"] = this.username;
      logindata["password"] = this.password;
      axios({
        method: "post",
        url: "/user/login",
        data: logindata,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status === true) {
            store.commit("loginUser");
            localStorage.setItem("token", response.data.data.token);
            // localStorage.setItem("role", response.data.role);
            this.appLoading = false;
            this.$router.push({ path: "/dashboard" });
            this.getProfile();
          } else {
            if (response.data.msg == "user not found.") {
              this.msg_username = response.data.msg;
              this.msg_password = null;
            } else {
              this.msg_password = response.data.msg;
              this.msg_username = null;
            }
          }
        })
        .catch((error) => {
          this.msg = error;
          this.errored = true;
          this.appLoading = false;
        });
    },
    getProfile() {
      // this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/me",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          //this.appLoading = false;
          if (response.data.status) {
            this.userData = response.data.data;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.login_head {
  font-family: opensans;
  font-size: 25px;
  font-weight: 400;
}
#app_signup {
  background-color: #2c3341;
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}
@media only screen and (min-width: 800px) {
  #app_height {
    min-height: 80vh;
  }
}
</style>